<template>
    <div class="card">
        <div class="card-body py-2">
            <div class="card-title pt-2">نمودار تولید محتوا</div>

            <bar-chart :chartData="chartData"></bar-chart>

            <div class="row mt-3 no-gutters text-center">
                <div class="col">
                    <div class=" bg-light">
                        <h6 class="p-2 ">تعداد کل</h6>
                        <h5 class="p-2 " dir="ltr">{{totalCount}}</h5>
                    </div>
                </div>
                <div class="col">
                    <div class=" bg-light">
                        <h6 class="p-2 ">امروز</h6>
                        <h5 class="p-2 " dir="ltr">{{todayCount}}</h5>
                    </div>
                </div>
                <div class="col">
                    <div class=" bg-light">
                        <h6 class="p-2 ">هفته قبل</h6>
                        <h5 class="p-2 " dir="ltr">{{weekCount}}</h5>
                    </div>
                </div>
                <div class="col">
                    <div class=" bg-light">
                        <h6 class="p-2 ">ماه قبل</h6>
                        <h5 class="p-2 " dir="ltr">{{monthCount}}</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import Vue from 'vue'
    import {Bar} from 'vue-chartjs'

    Vue.component('bar-chart', {
        extends: Bar,
        props: ['chartData'],
        watch: {
            chartData: function () {
                this.renderChart(this.chartData, {
                    legend: {display: false},
                    responsive: true, // my new default options
                    maintainAspectRatio: false, // my new default options

                    scales: {
                        yAxes: [{display: false}],
                        xAxes: [{
                            barPercentage: 0.9,
                            categoryPercentage: 1,
                            display: false
                        }]
                    }
                })
            }
        }
    })

    export default {
        name: "datachart",
        computed: {
            chartData: function () {
                return {

                    labels: this.datasetsLables,
                    datasets: [{
                        backgroundColor: '#007bff',
                        data: this.datasetsData
                    }]
                }
            }
        },
        data: function () {
            return {
                totalCount: null,
                todayCount: null,
                weekCount: null,
                monthCount: null,
                datasetsLables: [],
                datasetsData: []
            }
        },

        mounted: function () {
            let this2 = this;
            this.axios.get(this.url).then(function ({data}) {
                this2.totalCount = data.data.total;
                this2.todayCount = data.data.todey;
                this2.weekCount = data.data.week;
                this2.monthCount = data.data.month;
                this2.datasetsLables = [];
                this2.datasetsData = [];
                data.data.bars.forEach(function (v, i) {
                    this2.datasetsLables.push(this2.$moment(v.label).format( "jYYYY/jMM/jDD"))
                    this2.datasetsData.push(v.total)
                });
            });
        },
        props: ['url']
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/charts/Datachart.vue